export enum IConsentDetailsResultMode {
  ONLY_FORM = 'onlyFormControl',
  FORM_WITH_PREVIEW_HTML = 'formControlWithPreviewHtml',
}

export interface IConsentDetailsDialogConfig {
  showHtml: boolean;
  resultsMode: IConsentDetailsResultMode;
}

export class ConsentDetailsDialogConfig {
  static build(uiVersion: string): IConsentDetailsDialogConfig {
    switch (uiVersion) {
      case 'arval':
        return {
          showHtml: true,
          resultsMode: IConsentDetailsResultMode.FORM_WITH_PREVIEW_HTML,
        };
      default:
        return {
          showHtml: false,
          resultsMode: IConsentDetailsResultMode.ONLY_FORM,
        };
    }
  }
}
